<pannel [title]="'Consignes & mesures générales de sécurité de l’EU'" [expandable]="true"> 
	<!-- Obligations -->
	<div *ngIf="traductionsObligations">
		<h4><b>Obligations pour l’EE</b></h4>
		<ul>
			<li *ngFor="let item of traductionsObligations" [class.no-bullet]="item.presentation === 'CHECKBOX'">
				<ng-container *ngIf="item.presentation === 'TICK' || item.presentation === 'CROSS'">
					<span>{{ item.fr }}</span>
				</ng-container>
				
				<ng-container *ngIf="item.presentation === 'CHECKBOX'">
					<label>
						<input type="checkbox" [(ngModel)]="item.checked" />
					  	{{ item.fr }}
					</label>
				</ng-container>
			</li>
		</ul>
	</div>
	
	<!-- Interdictions -->
	<div *ngIf="traductionsInterdictions">
		<h4><b>Interdictions pour l’EE</b></h4>
		<ul>
		    <ng-container *ngFor="let item of traductionsInterdictions">
		        <li *ngIf="item.presentation === 'TICK' || item.presentation === 'CROSS'">
		            <span>{{ item.fr }}</span>
		        </li>
		    </ng-container>
		</ul>
		<div *ngFor="let item of traductionsInterdictions">
		    <ng-container *ngIf="item.presentation === 'RADIOBUTTON'">
		        <label class="checkbox-item">
		            <input type="radio" name="interdictionRadioGroup" [value]="item.id" [(ngModel)]="selectedInterdiction" 
		            (ngModelChange)="onInterdictionRadioChange($event)" [disabled]="currentPaInstance | disablePaField"/>
		            {{ item.fr }}
		        </label>
		    </ng-container>
		</div>
	</div>
</pannel>

<document-pa-step-actions [documentPaButtons]="actionButtons" (onButtonPressed)="performAction($event)" ></document-pa-step-actions>
